import useContext from "../../../context";
 
const dollars = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});

export default function QuoteDetails() {
  const [context, updateContext] = useContext();

  const loan = context.response[context.loanOption];
  const isRefinance = context.contractType === 'refinance';

  return (
    <div className="quoteform__column">
      <button class="quoteform__back" onClick={() => updateContext((ctx) => {
        ctx.loanOption = null;

        return ctx;
      })}>
        <i className="fas fa-arrow-left" />
        <span className="quoteform__back-text">Back to quote</span>
      </button>
      <div className="quoteform__infogroup quoteform__infogroup--noBorder">
        <div className="quoteform__heading">Your Contract Info</div>
        <div className="quoteform__infogroup-loop">
          <div className="quoteform__infogroup-item quoteform__infogroup-item--isFull">
            <div className="quoteform__infogroup-title">Resort</div>
            <div className="quoteform__infogroup-value">{context.resort}</div>
          </div>
          <div className="quoteform__infogroup-item">
            <div className="quoteform__infogroup-title">Number of Points</div>
            <div className="quoteform__infogroup-value">{context.totalPoints}</div>
          </div>
          {!isRefinance && (
            <div className="quoteform__infogroup-item">
              <div className="quoteform__infogroup-title">Cost Per Point</div>
              <div className="quoteform__infogroup-value">{dollars.format(context.pricePerPoint)}</div>
            </div>
          )}
          <div className="quoteform__infogroup-item">
            <div className="quoteform__infogroup-title">Purchase Price</div>
            <div className="quoteform__infogroup-value">{dollars.format(isRefinance ? loan.total_loan_amount : loan.purchase_price)}</div>
          </div>
        </div>
      </div>
      <div className="quoteform__infogroup">
        <div className="quoteform__heading">Selected Loan Terms</div>
        <div className="quoteform__infogroup-loop">
          <div className="quoteform__infogroup-item">
            <div className="quoteform__infogroup-title">Length of Loan</div>
            <div className="quoteform__infogroup-value">{loan.loan_term}</div>
          </div>
          <div className="quoteform__infogroup-item">
            <div className="quoteform__infogroup-title">Total Loan Amount</div>
            <div className="quoteform__infogroup-value">{dollars.format(loan.total_loan_amount)}</div>
          </div>
          <div className="quoteform__infogroup-item">
            <div className="quoteform__infogroup-title">Interest Rate</div>
            <div className="quoteform__infogroup-value">{loan.interest_rate}%</div>
          </div>
          <div className="quoteform__infogroup-item">
            <div className="quoteform__infogroup-title">Monthly Payment</div>
            <div className="quoteform__infogroup-value">{dollars.format(loan.monthly_payment)}</div>
          </div>
        </div>
      </div>
      <div className="quoteform__listgroup">
        <div className="quoteform__listgroup-item">
          <div className="quoteform__listgroup-title quoteform__listgroup-title--isBig">{isRefinance ? 'Estimated Proceeds after Closing' : 'Estimated Cash to Close'}{isRefinance ? <span className="negative">*</span> : ''}</div>
          <div className="quoteform__listgroup-value quoteform__listgroup-value--isBig">{dollars.format(isRefinance ? loan.estimated_proceeds : loan.estimated_cash_to_close)}</div>
        </div>
        {
          loan.estimated_cash_details.map((item) => (
            <div className="quoteform__listgroup-item" key={item.key || item.label}>
              <span className="quoteform__listgroup-title">{item.label}</span>
              <span className="quoteform__listgroup-value">{item.operator === '-' ? '-' : ''}{dollars.format(item.value)}</span>
            </div>
          ))
        }
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/components/QuoteDetails.js